import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { startBuscaAsistenciaIDV2 } from '../../../../context/actions/pagos2Actions';

export default function BuscarPorAsistenciaID() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [asistenciaID, setAsistenciaID] = useState('');
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (!asistenciaID) return;

    setLoading(true);

    try {
      const respuesta = await dispatch(startBuscaAsistenciaIDV2(asistenciaID));

      if (respuesta.success) {
        history.push(`/ordenesPagoV2/detalle/${respuesta.ordenPagoID}`);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleClick();
    }
  };

  return (
    <Input
      placeholder="Asistencia ID"
      value={asistenciaID}
      onChange={(e) => setAsistenciaID(e.target.value)}
      onKeyPress={handleKeyPress}
      style={{ width: 130 }}
      suffix={
        <SearchOutlined
          onClick={handleClick}
          className="ant-input-search-icon"
        />
      }
    />
  );
}
